export const translationEngDefault = {
    SkhemataBlogSearch: {
        searchPlaceholder: 'Enter Search Keyword...',
    }
};
//# sourceMappingURL=eng.js.map